import ArticlePage from './ArticlePage';
import { guideArticles } from '@/mocks/articles';

export default function BeginnerTutorialPage() {
  return <ArticlePage data={guideArticles.beginner} />;
}